/**
 * DoorDrop feature flag.
 *
 * DOORDROP_ENABLED gates DoorDrop (the direct-mail campaign feature) across the
 * app — the sidebar entry and the /marketing/doordrop* authoring routes. It's a
 * build-time env flag (mirrors src/features/routes/flags.ts): default OFF, set
 * VITE_ENABLE_DOORDROP=true to surface it. Because Vite inlines env vars at
 * build time, flipping it requires a redeploy. This sits on top of the existing
 * per-org `doordrop` entitlement + `tab.doordrop` permission.
 */
export const DOORDROP_ENABLED = import.meta.env.VITE_ENABLE_DOORDROP === 'true';
